import type {
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  SocialLoginParams,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export const login = async (data: LoginRequest): Promise<LoginResponse> => {
  const response = await httpClient.post<LoginResponse>("/auth/login", data);
  return response.data;
};

export const logout = async (): Promise<LogoutResponse> => {
  const response = await httpClient.post<LogoutResponse>("/auth/logout");
  return response.data;
};

export const socialLogin = async (data: SocialLoginParams): Promise<LoginResponse> => {
  const response = await httpClient.post<LoginResponse>("/auth/social/login", data);
  return response.data;
};
